module.exports = "/images/bg_everest44.jpg?02e771823f5da3a2a6e714e843e4e2b0";